import React from 'react'

const defaultContext = {
  disabledAll: false,
  inGroup: false,
  values: [],
  size: 'xl',
  updateState: null
}

export const CheckboxContext = React.createContext(defaultContext)
export const useCheckbox = () => React.useContext(CheckboxContext)
